import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PlantContext = createContext(null);

export const PlantProvider = ({ children }) => {
  const { user } = useAuth();
  const [plants, setPlants] = useState([]);
  const [plantId, setPlantIdRaw] = useState(localStorage.getItem("plant_id") || "");

  useEffect(() => {
    if (!user || user === false) return;
    api.get("/plants").then((r) => {
      setPlants(r.data);
      const stored = localStorage.getItem("plant_id");
      if ((!stored || !r.data.find((p) => p.id === stored)) && r.data.length) {
        setPlantIdRaw(r.data[0].id);
        localStorage.setItem("plant_id", r.data[0].id);
      } else if (stored) {
        setPlantIdRaw(stored);
      }
    }).catch(() => {});
  }, [user]);

  const setPlantId = (id) => {
    setPlantIdRaw(id);
    localStorage.setItem("plant_id", id);
  };

  const currentPlant = plants.find((p) => p.id === plantId);
  const plantParam = plantId ? `plant_id=${plantId}` : "";

  return (
    <PlantContext.Provider value={{ plants, plantId, setPlantId, currentPlant, plantParam }}>
      {children}
    </PlantContext.Provider>
  );
};

export const usePlant = () => useContext(PlantContext);
